// extracted by mini-css-extract-plugin
export default {"number":"Footer_number__+C7JM"};